export const SC_DARK_PINK = '#FF1677';
export const SC_PINK = '#FF7DB1';
export const SC_LIGHT_GRAY = '#D4DDE4';
export const SC_GRAY = '#647079';
export const SC_BLACK = '#1A1D1F';
export const SC_BLUE = '#0E99FD';
export const SC_WHITE = '#E0E0E0';
export const SC_BRIGHT_WHITE = '#FFFFFF';
export const SC_GRAY_BLUE = '#93ABBC';
export const SC_LIGHT_GRAY_BLUE = '#F5F9FC';
export const SC_GREEN = '#22BF54';
export const SC_RED = '#FF5B5B';
export const SC_BORDER_GRAY = '#DCE5EB';
export const SC_YELLOW = '#FFFEE3';
export const SC_RED_WARNING = '#FFEBEF';
export const SC_GREEN_SUCCESS = '#EBFFF2';
export const SC_ORANGE = '#FF7F00';

export const DefaultTheme = {
  messages: {
    normal: { color: SC_LIGHT_GRAY_BLUE },
    secondary: { color: SC_LIGHT_GRAY_BLUE },
    info: { color: SC_LIGHT_GRAY_BLUE },
    warning: { color: SC_YELLOW },
    error: { color: SC_RED_WARNING },
    success: { color: SC_GREEN_SUCCESS },
  },
  config: {
    themeName: 'Default Theme',
  },
  dropdown: {
    menuItem: {
      hoverBgColor: 'whitesmoke',
      hoverColor: 'black',
    },
  },
  header: {
    description: {
      color: SC_GRAY_BLUE,
    },
    heading: {
      color: SC_BLACK,
    },
  },
  iconButton: {
    normal: { color: SC_GRAY, bgColor: SC_WHITE, hoverColor: SC_PINK },
  },
  sidebar: {
    dropdown: {
      bgColor: SC_BLACK,
    },
    normal: {
      bgColor: SC_BLACK,
    },
  },
  tab: {
    normal: { color: SC_BLACK },
    primary: { color: SC_BLUE },
    secondary: { color: SC_PINK },
  },
  window: {
    width: {
      extraLarge: 1200,
      large: 992,
      medium: 800,
      small: 576,
    },
  },
};

export const MAINNAV_WIDTH = 240;
export const MAINNAV_COLLAPSE_WIDTH = 52;

export const DEFAULT_ICON_PREFIX = 'far';
